/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import { FormattedMessage } from 'react-intl';

const scopes: {
  [scope: string]: {
    [msgId: string]: string;
  };
} = {};

export function createMessageFactory(scope: string):
  (descriptor: FormattedMessage.MessageDescriptor) => FormattedMessage.MessageDescriptor {
  if (scopes[scope]) {
    throw new Error(`Duplicated scope: ${scope}`);
  }
  scopes[scope] = {};

  return (descriptor: FormattedMessage.MessageDescriptor): FormattedMessage.MessageDescriptor => {
    const mergedId = `${scope}::${descriptor.id}`;

    // this function is called everytime the component rerenders
    // in order to know if it's really a duplication (instead of re-rendering),
    // we simply compare the default message
    if (scopes[scope][descriptor.id] && scopes[scope][descriptor.id] !== descriptor.defaultMessage) {
      throw new Error(`Duplicated id: ${descriptor.id}, in scope: [${scope}]`);
    }
    scopes[scope][descriptor.id] = descriptor.defaultMessage || '';
    return {
      id: mergedId,
      defaultMessage: descriptor.defaultMessage,
      description: descriptor.description
    };

  };
}
